module.exports = __webpack_public_path__ + "img/futbol.0661d2ae.svg";